export default __webpack_public_path__ + "static/migrate-1e99b2e42c551bdf608a98265d067585.webp";